import React from "react";

import Background from "../../../assets/clothes/clothes-bg.png";
import Image from "../../../assets/clothes/clothes-choice-b.png";

import GamePageLayout from "../GamePageLayout";

const ClothesPage4 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      img={Image}
      onClickNext={() => setCurrentPage("ending")}
    >
      옷 분리배출 방법??
      <br />
      아, 다 복합재질이라 재활용이
      <br />
      안 된다고 하니
      <br />
      그냥 일반 쓰레기로 버려야겠다.
    </GamePageLayout>
  );
};

export default ClothesPage4;
